module.exports = __webpack_public_path__ + "img/course_selected.4b60ca10.svg";